function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#de2910",
  d: "M 0 0 L 512 0 L 512 512 L 0 512 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "M 204.8 104.96 L 74.24 189.44 L 128 51.2 L 174.08 189.44 L 51.2 104.96 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "M 279.721 47.226 L 236.231 75.367 L 254.138 29.318 L 269.488 75.367 L 228.556 47.226 Z",
  transform: "matrix(-0.515038, -0.857167, 0.857167, -0.515038, 340.163232, 297.140094)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "M 330.146 97.711 L 286.626 125.871 L 304.546 79.791 L 319.906 125.871 L 278.946 97.711 Z",
  transform: "matrix(-0.140901, -0.990024, 0.990024, -0.140901, 245.65178, 418.827764)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "M 330.052 173.442 L 286.508 201.617 L 304.438 155.512 L 319.806 201.617 L 278.824 173.442 Z",
  transform: "matrix(0.275637, -0.961262, 0.961262, 0.275637, 48.876303, 421.990043)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "M 279.591 223.682 L 236.092 251.829 L 254.003 205.771 L 269.356 251.829 L 228.416 223.682 Z",
  transform: "matrix(0.625305, -0.780381, 0.780381, 0.625305, -83.377196, 283.949625)"
}));

var SvgCn = function SvgCn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-cn",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cn.cc4cb2f1.svg";
export { ForwardRef as ReactComponent };